export function formatCurrency(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(Number(value || 0));
}

export function formatPercent(value) {
  return `${Number(value || 0).toFixed(2)}%`;
}

export function statusBadgeClass(status) {
  if (status === 'critical') return 'badge-danger';
  if (status === 'alert') return 'badge-warning';
  return 'badge-success';
}

export function statusLabel(status) {
  if (status === 'critical') return 'Crítico';
  if (status === 'alert') return 'Alerta';
  return 'OK';
}
